import React from 'react';
import {
  Button,
  Input,
  Form,
  FormItem,
  SubmitButton,
} from '../../../../components';
import { SIP_PROVIDER_LABELS } from '../constants';
import {
  validateProviderName,
  validateProviderDescription,
} from '../utils/validator';
import type { SipProviderFormData } from '../types';

interface SipProviderFormProps {
  formValues: SipProviderFormData;
  setFormValues: (values: SipProviderFormData) => void;
  isEdit?: boolean;
  onSave: (data: SipProviderFormData) => void;
  onCancel: () => void;
  loading?: boolean;
}

export const SipProviderForm: React.FC<SipProviderFormProps> = ({
  formValues,
  setFormValues,
  isEdit = false,
  onSave,
  onCancel,
  loading = false,
}) => {
  const handleSaveData = () => {
    onSave(formValues);
  };

  return (
    <form autoComplete="off" onSubmit={e => e.preventDefault()}>
      <div className="relative bg-white w-full rounded-xl p-6 flex min-h-[300px] overflow-hidden">
        <Form initialValue={formValues} onChange={setFormValues}>
          <div className="w-full flex flex-col gap-4">
            <FormItem
              name="name"
              label={SIP_PROVIDER_LABELS.PROVIDER_NAME}
              required
              validate={validateProviderName}
              inline={false}
            >
              <Input placeholder="Enter provider name" disabled={loading} />
            </FormItem>

            <FormItem
              name="description"
              label={SIP_PROVIDER_LABELS.DESCRIPTION}
              validate={validateProviderDescription}
              inline={false}
            >
              <Input
                multiline
                placeholder="Enter description"
                disabled={loading}
              />
            </FormItem>

            <div className="flex justify-end space-x-3 pt-4">
              <Button
                label="Cancel"
                onClick={onCancel}
                disabled={loading}
                className="bg-gray-500 hover:bg-gray-600 text-white"
              />
              <SubmitButton
                label={isEdit ? 'Update' : 'Create'}
                disabled={loading}
                loading={loading}
                onClick={handleSaveData}
              />
            </div>
          </div>
        </Form>
      </div>
    </form>
  );
};
